import React from "react";

/*eslint-disable */

declare const window: any;
const TitleComponent: React.FC = () => {
  return (
    <h1 className="title-politicas-component">TÉRMINOS Y CONDICIONES DE USO RESERVA ONLINE DE VEHÍCULOS</h1>
  );
};

export default TitleComponent;
